// Trả lời có gắn "@tên người được trả lời" (kiểu Facebook).
// Không đổi DB: mention chỉ là text thuần đứng đầu nội dung reply ("@Tên nội dung...").
// Tên user có thể chứa khoảng trắng nên KHÔNG tách được bằng regex \S+ —
// phải đối chiếu với danh sách tên có thật trong luồng (tác giả bình luận gốc
// + tác giả các trả lời), ưu tiên tên dài nhất khớp (tránh "An" ăn mất "An Nguyen").

/** Chuỗi prefill cho ô nhập khi bấm "Trả lời" một reply */
export function mentionPrefix(name) {
    return name ? `@${name} ` : '';
}

/**
 * Tách mention đứng đầu nội dung.
 * @returns {{ mention: string|null, rest: string }}
 */
export function splitLeadingMention(text, knownNames = []) {
    const raw = String(text ?? '');
    if (!raw.startsWith('@')) return { mention: null, rest: raw };

    const body = raw.slice(1);
    const matched = knownNames
        .filter(Boolean)
        .filter((name) => body.startsWith(name))
        .sort((a, b) => b.length - a.length)[0];

    if (!matched) return { mention: null, rest: raw };
    return { mention: matched, rest: body.slice(matched.length).replace(/^\s+/, '') };
}

/** Danh sách tên có thật trong 1 luồng bình luận (dùng để nhận diện mention) */
export function threadNames(comment) {
    return [comment?.user?.name, ...(comment?.replies ?? []).map((r) => r?.user?.name)].filter(
        Boolean
    );
}
